<template>
  <v-card>
    <v-card-title>
      Permissions<v-spacer />
      <!-- <v-btn
        @click="addItem"
        x-small
        v-show="
          userGroupList.length !== 0 && userGroupList.length !== items.length
        "
        ><v-icon>mdi-plus</v-icon>
      </v-btn> -->
    </v-card-title>
    <v-card-text style="overflow-y: auto">
      <table width="100%" border="0" cellpadding="10" cellspacing="10">
        <tr v-for="(item, i) in items" :key="i">
          <!-- <td>
            <v-btn @click="removeItem(i)" x-small
              ><v-icon>mdi-delete</v-icon></v-btn
            >
          </td> -->
          <td>
            <!-- <UserGroupSelect v-model="item.userGroupId" /> -->
            {{ item.items[0].userGroupName }}
          </td>
          <td v-for="(item2, ii) in item.items" :key="ii">
            <v-switch
              v-model="item2.access"
              :label="actionList[item2.userActionId]"
              color="blue"
            />
          </td>
        </tr>
      </table>
    </v-card-text>
  </v-card>
</template>

<script>
// import UserGroupSelect from "components/UserGroupSelect";
export default {
  components: {
    // UserGroupSelect,
  },
  props: {
    value: [Array],
  },
  data() {
    return {
      loading: false,
      selected: null,
      actionList: {
        1: "View",
        2: "Add",
        3: "Edit",
        4: "Delete",
      },
      items: this.allItems,
    };
  },

  watch: {
    value(n, o) {
      if (JSON.stringify(o) !== JSON.stringify(n)) {
        this.items = this.allItems;
      }
    },
    items: {
      deep: true,
      handler(value) {
        this.$emit("input", this.formatValue(value));
      },
    },
  },

  async created() {
    await this.$store.dispatch("userGroup/getAll");
    this.items = this.allItems;
  },

  methods: {
    checkValue(userGroupId, userActionId) {
      let valueInArray = this.value || [];
      let found = valueInArray.filter((item) => {
        if (
          userGroupId == item.userGroupId &&
          userActionId == item.userActionId
        ) {
          return true;
        }
        return false;
      });
      if (found.length === 1) {
        return found[0].access;
      }
      return false;
    },

    deformatValue(items) {
      let formattedPermissions = items.map((permission) => {
        return permission.userGroupId;
      });
      let unique = [...new Set(formattedPermissions)];
      let x = [];
      unique.forEach((userGroupId) => {
        let xx = items.filter((perm) => {
          return perm.userGroupId == userGroupId;
        });
        x.push({
          userGroupId: userGroupId,
          items: xx,
        });
      });
      return x;
    },
    formatValue(items) {
      let allItems = items.map((item) => {
        return item.items.map((item2) => {
          return {
            ...item2,
            userGroupId: item.userGroupId,
          };
        });
      });

      let result = [];
      allItems.forEach((allItem) => {
        allItem.forEach((all2) => {
          result.push(all2);
        });
      });

      return result;
    },
    removeItem(idx) {
      this.items.splice(idx, 1);
    },
    addItem() {
      this.items.push({
        userGroupId: null,
        items: [
          {
            userGroupId: null,
            userActionId: 1,
            access: false,
          },
          {
            userGroupId: null,
            userActionId: 3,
            access: false,
          },
          {
            userGroupId: null,
            userActionId: 4,
            access: false,
          },
        ],
      });
    },
  },

  computed: {
    userGroupList() {
      return this.$store.getters["userGroup/getAllFromLatest"];
    },

    allItems() {
      return this.userGroupList.map((allItem) => {
        let value1 = this.checkValue(allItem.id, 1);
        let value3 = this.checkValue(allItem.id, 3);
        let value4 = this.checkValue(allItem.id, 4);

        // set defalt switch to true
        if (allItem.name === 'Super Admin') {
          value1 = true;
          value3 = true;
          value4 = true;
        }
        return {
          userGroupId: allItem.id,
          items: [
            {
              userGroupId: allItem.id,
              userGroupName: allItem.name,
              userActionId: 1,
              access: value1,
            },
            {
              userGroupId: allItem.id,
              userGroupName: allItem.name,
              userActionId: 3,
              access: value3,
            },
            {
              userGroupId: allItem.id,
              userGroupName: allItem.name,
              userActionId: 4,
              access: value4,
            },
          ],
        };
      });
    },

    computedValue() {
      return this.items;
    },
  },
};
</script>